module.exports = __webpack_public_path__ + "static/media/muscle_back_19.046bc512.png";